export const USERS = "users";
export const RESTAURANTS = "restaurants";
export const RESERVATIONS = "reservations";
export const RESERVATIONS_BY_USER = "reservationsByUser";
export const CATEGORIES2 = "categories2";
export const HITOS = "hitos";
export const CITIES = "cities";
export const SERVICES = "services";
export const TYPES = "types";
export const STYLES = "styles";
export const COUNTRIES = "countries";
export const PROVINCES = "provinces";
export const NEIGHBORHOODS = "neighborhoods";
export const PROMOTIONS = "promotions";
export const CONFIG = "config";
export const MAIN_SLIDER = "mainSlider";
export const COMMENTSANDRATINGS = "commentsAndRatings";
export const PLACES = "places";
export const RESERVATIONS_ASSISTED_BY_RESTAURANT = "reservationsAssistedByRestaurant";